import { useTranslation } from "react-i18next";

const HeroSection = () => {
  const { t } = useTranslation();

  const handleScrollToForm = () => {
    const formElement = document.getElementById("contacts");
    if (formElement) {
      formElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      id="hero-section"
      className="w-full min-h-[600px] md:min-h-[810px] relative overflow-hidden flex items-end"
    >
      {/* Фон суреті */}
      <div className="absolute inset-0 z-0 bg-[url('/8-min%201.png')] bg-cover bg-center bg-no-repeat">
        {/* Градиент overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-stone-900/0 to-black" />
      </div>

      {/* Контент */}
      <div className="relative z-10 w-full mx-auto px-5 md:px-20 pb-12 md:pb-20">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 lg:gap-8">
          {/* Сол жақ - мәтіндер */}
          <div className="flex flex-col gap-4 lg:gap-6 text-center md:text-left">
            <h1 className="text-white text-[48px] md:text-5xl lg:text-6xl font-normal font-['Forum'] uppercase leading-[40px] md:leading-[66px]">
              {t("hero.title")}
            </h1>
            <p className="text-white text-[20px] md:text-2xl font-light font-['Inter'] leading-[24px] md:leading-7 max-w-3xl">
              {t("hero.subtitle")}
            </p>
          </div>

          {/* Оң жақ - кнопка */}
          <div className="flex-shrink-0">
            <button
              onClick={handleScrollToForm}
              className="w-full sm:w-96 h-16 sm:h-24 border-2 border-white text-white text-[16px] md:text-xl font-normal font-['Inter'] leading-[33px] md:leading-8   transition-colors duration-300 px-6
            hover:bg-red-900  hover:border-red-900 cursor-pointer
            "
            >
              {t("hero.cta")}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;

